import Vue from 'vue'
import Router from 'vue-router'

import QuizPage from './views/QuizPage'
import LoginPage from './views/LoginPage'
import MedalPage from './views/MedalPage'
import ClubDetail from './views/ClubDetail'
import FreePlay from './views/FreePlay'
import ProtectionForm from './views/ProtectionForm'
import AdminDashboard from './views/AdminDashboard'
import FinalClubInfo from './views/FinalClubInfo'
import MedalForm from './views/MedalForm'
import LeaderBoard from './views/LeaderBoard.vue'
import RegluvardarShare from './views/RegluvardarShare.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/innskraning/',
      name: 'Login',
      component: LoginPage,
      meta: { title: 'Login Page' }
    },
    {
      path: '/spurningar/',
      name: 'Quiz',
      component: QuizPage,
      meta: { title: 'Quiz Page' }
    },
    {
      path: '/verdlaun/',
      name: 'MedalPageOld',
      component: MedalPage,
      meta: { title: 'MedalPage' }
    },
    {
      path: '/klubbur/upplysingar/',
      name: 'ClubDetail',
      component: ClubDetail,
      meta: { title: 'ClubDetail' }
    },
    {
      path: '/fb/share/',
      name: 'RegluvardarShare',
      component: RegluvardarShare,
      meta: { title: 'RegluvardarShare' }
    },
    {
      path: '/frjals-spilun/',
      name: 'FreePlay',
      component: FreePlay,
      meta: { title: 'FreePlay' }
    },
    {
      path: '/admin/dashboard/',
      name: 'AdminDashboard',
      component: AdminDashboard,
      meta: { title: 'AdminDashboard' }
    },
    {
      path: '/golfvernd/',
      name: 'ProtectionForm',
      component: ProtectionForm,
      meta: { title: 'ProtectionForm', hideHeader: true }
    },
    {
      path: '/leik-lokid/',
      name: 'FinalClubInfo',
      component: FinalClubInfo,
      meta: { title: 'FinalClubInfo' }
    },
    {
      path: '/medal-form-r2020',
      name: 'MedalForm',
      component: MedalForm,
      meta: { title: 'MedalForm' }
    },
    {
      path: '/medal/skraning/',
      name: 'MedalPage',
      component: MedalPage,
      meta: { title: 'MedalPage' }
    },
    {
      path: '/leader-board',
      name: 'LeaderBoard',
      component: LeaderBoard,
      meta: { title: 'LeaderBoard' }
    },
    {
      path: '/leader-board/:clubName/',
      name: 'ClubLeaderBoard',
      component: LeaderBoard,
      meta: { title: 'ClubLeaderBoard' },
      params: { clubName: '' },
    }
  ]
})
